import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is AstroIndia and how does it help me?',
      answer: 'AstroIndia is a Vedic astrology platform that helps you understand your life path, career, finances, relationships, and timing through accurate Kundli-based analysis by expert astrologers.'
    },
    {
      question: 'Is AstroIndia astrology based on Vedic principles?',
      answer: 'Yes. All predictions and analyses on AstroIndia are strictly based on authentic Vedic astrology principles, including planetary placements, nakshatras, dashas, and classical astrological texts.'
    },
    {
      question: 'How accurate are AstroIndia predictions?',
      answer: 'AstroIndia focuses on Kundli-based, data-driven astrology rather than generic horoscopes. Accuracy depends on correct birth details and is enhanced through detailed chart analysis and experienced astrologers.'
    },
    {
      question: 'Can I consult an astrologer directly on AstroIndia?',
      answer: 'Yes. AstroIndia allows you to consult verified astrologers directly through chat or call for personalized guidance on career, wealth, relationships, health, and major life decisions.'
    },
    {
      question: 'Is AstroIndia suitable for beginners who don’t know astrology?',
      answer: 'Absolutely. AstroIndia is designed for everyone. Even if you have no prior astrology knowledge, reports and consultations are explained in clear, practical language that’s easy to understand and apply.'
    }


  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="section-title">Frequently asked questions</h2>
      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              <span>{faq.question}</span>
              <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
            </button>
            {openIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;

